import * as React from "react";
import { motion } from "framer-motion";
import { MenuButton } from "./Header.Styled";

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="2.2"
    stroke="currentColor"
    strokeLinecap="round"
    {...props}
  />
);

export const MenuToggle = ({ buttonRef, toggle, isOpen }) => (
  <MenuButton
    ref={buttonRef}
    $isOpen={isOpen}
    type="button"
    onClick={toggle}
    aria-label={isOpen ? "Close navigation" : "Open navigation"}
    aria-expanded={isOpen}
    aria-controls="mobile-navigation"
  >
    <motion.svg
      aria-hidden="true"
      focusable="false"
      width="21"
      height="21"
      viewBox="0 0 23 23"
      initial={false}
      animate={isOpen ? "open" : "closed"}
    >
      <Path
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" },
        }}
        transition={{ duration: 0.25, ease: "easeOut" }}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 },
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: "M 2 16.346 L 20 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" },
        }}
        transition={{ duration: 0.25, ease: "easeOut" }}
      />
    </motion.svg>
  </MenuButton>
);
